import { render, staticRenderFns } from "./CreateFlight.vue?vue&type=template&id=5199dd06&scoped=true&"
import script from "./CreateFlight.vue?vue&type=script&lang=js&"
export * from "./CreateFlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5199dd06",
  null
  
)

export default component.exports